import { App } from '@capacitor/app';
import { useQuery } from '@tanstack/react-query';

export const useCapacitorAppInfo = () => {
  return useQuery({
    queryKey: ['CAPACITOR_APP_INFO'],
    queryFn: async () => App.getInfo(),
    staleTime: Infinity,
  });
};
